const NUMBER_WORDS = [
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "ten",
];

function toWord(n: number): string {
  return NUMBER_WORDS[n] ?? String(n);
}

/**
 * Format score settings for display.
 *
 * Single set:  "One to 28, switch every 7"
 * Best of 3:   "Best of 3, two to 21 and one to 15, switch every 7"
 */
export function formatScoreSettings(
  sets: { winScore: number; switchScore?: number | null }[],
): string {
  if (sets.length === 0) return "";

  if (sets.length === 1) {
    const s = sets[0];
    const switchPart = s.switchScore ? `, switch every ${s.switchScore}` : "";
    return `One to ${s.winScore}${switchPart}`;
  }

  // Group sets by winScore
  const groups = new Map<number, number>();
  for (const s of sets) {
    groups.set(s.winScore, (groups.get(s.winScore) ?? 0) + 1);
  }

  const scoreParts = [...groups.entries()].map(
    ([score, count]) => `${toWord(count)} to ${score}`,
  );

  // Find the most common switchScore
  const switchScores = sets
    .map((s) => s.switchScore)
    .filter((v): v is number => v != null);
  const switchPart =
    switchScores.length > 0 ? `, switch every ${switchScores[0]}` : "";

  const joinedScores =
    scoreParts.length > 1
      ? `${scoreParts.slice(0, -1).join(", ")} and ${scoreParts.at(-1)}`
      : scoreParts[0];

  return `Best of ${sets.length}, ${joinedScores}${switchPart}`;
}

export const POOL_MATCH_DEFAULTS: {
  [teamCount: number]: {
    sets: { winScore: number; switchScore: number | null }[];
  };
} = {
  3: {
    sets: [
      { winScore: 21, switchScore: 7 },
      { winScore: 21, switchScore: 7 },
      { winScore: 15, switchScore: 5 },
    ],
  },
  4: { sets: [{ winScore: 28, switchScore: 7 }] },
  5: { sets: [{ winScore: 21, switchScore: 7 }] },
  6: { sets: [{ winScore: 21, switchScore: 7 }] },
  7: { sets: [{ winScore: 21, switchScore: 7 }] },
};
